import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

import type { SvgIconComponent } from '@mui/icons-material';
import type { KeyboardEvent } from 'react';

const StyledFilePreviewBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size' && prop !== 'clickable',
})<{ size: number; clickable: boolean }>(({ theme, size, clickable }) => ({
  width: size,
  height: size,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: 8,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.grey[100],
  ...(clickable && {
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  }),
}));

export interface FilePreviewBoxProps {
  icon: SvgIconComponent;
  iconColor: string;
  label: string;
  size?: number;
  iconSize?: number;
  onClick?: () => void;
}

export const FilePreviewBox = ({
  icon: Icon,
  iconColor,
  label,
  size = 140,
  iconSize = 40,
  onClick,
}: FilePreviewBoxProps) => {
  const clickable = Boolean(onClick);
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  };

  return (
    <StyledFilePreviewBox
      size={size}
      clickable={clickable}
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={clickable ? handleKeyDown : undefined}
    >
      <Icon sx={{ fontSize: iconSize, color: iconColor }} aria-hidden />
      <Text
        sx={{
          fontSize: 10,
          color: 'text.secondary',
          textAlign: 'center',
          mt: 0.5,
        }}
      >
        {label}
      </Text>
    </StyledFilePreviewBox>
  );
};
